import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.jsx';

export function SkeletonCard() {
  const { theme } = useTheme();
  return (
    <div style={{
      ...styles.card,
      backgroundColor: theme === 'dark' ? 'var(--color-bg-secondary-dark)' : 'var(--color-bg-secondary)',
    }}>
      <div style={{
        ...styles.shimmer,
        backgroundColor: theme === 'dark' ? 'var(--color-bg-tertiary-dark)' : 'var(--color-bg-tertiary)',
      }} />
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4 }) {
  const { theme } = useTheme();
  return (
    <div style={{
      ...styles.tableContainer,
      backgroundColor: theme === 'dark' ? 'var(--color-bg-primary-dark)' : 'var(--color-bg-primary)',
      border: `1px solid ${theme === 'dark' ? 'var(--color-border-light-dark)' : 'var(--color-border-light)'}`,
    }}>
      <div style={styles.tableHeader}>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} style={{
            ...styles.tableHeaderCell,
            ...styles.shimmer,
            backgroundColor: theme === 'dark' ? 'var(--color-bg-tertiary-dark)' : 'var(--color-bg-tertiary)',
          }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={styles.tableRow}>
          {Array.from({ length: cols }).map((_, j) => (
            <div key={j} style={{
              ...styles.tableCell,
              ...styles.shimmer,
              backgroundColor: theme === 'dark' ? 'var(--color-bg-tertiary-dark)' : 'var(--color-bg-tertiary)',
            }} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonText({ lines = 3, width = '100%' }) {
  const { theme } = useTheme();
  return (
    <div style={styles.textContainer}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          style={{
            ...styles.textLine,
            ...styles.shimmer,
            width: i === lines - 1 ? '60%' : width,
            backgroundColor: theme === 'dark' ? 'var(--color-bg-tertiary-dark)' : 'var(--color-bg-tertiary)',
          }}
        />
      ))}
    </div>
  );
}

const styles = {
  card: {
    padding: 'var(--spacing-6)',
    borderRadius: 'var(--radius-lg)',
    border: '1px solid var(--color-border-light)',
    minHeight: '200px',
    position: 'relative',
    overflow: 'hidden',
  },
  shimmer: {
    animation: 'shimmer 1.5s ease-in-out infinite',
    borderRadius: 'var(--radius-sm)',
  },
  tableContainer: {
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--spacing-4)',
    overflow: 'hidden',
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gap: 'var(--spacing-4)',
    marginBottom: 'var(--spacing-4)',
    paddingBottom: 'var(--spacing-3)',
    borderBottom: '1px solid var(--color-border-light)',
  },
  tableHeaderCell: {
    height: '20px',
    borderRadius: 'var(--radius-sm)',
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gap: 'var(--spacing-4)',
    marginBottom: 'var(--spacing-3)',
  },
  tableCell: {
    height: '16px',
    borderRadius: 'var(--radius-sm)',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-2)',
  },
  textLine: {
    height: '16px',
    borderRadius: 'var(--radius-sm)',
  },
};

// Add shimmer animation to global CSS
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes shimmer {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
  `;
  if (!document.head.querySelector('style[data-skeleton-shimmer]')) {
    style.setAttribute('data-skeleton-shimmer', 'true');
    document.head.appendChild(style);
  }
}

